export default __webpack_public_path__ + "static/media/green-felt.3e6bf03d.webp";